import Vue from 'vue';
import App from './App';
import iView from 'iview';
import Vuebar from 'vuebar';
import vueCookie from './cookie';

import 'iview/dist/styles/iview.css';
import '@/assets/iconfont.css';

Vue.use(iView);
Vue.use(Vuebar);
Vue.use(vueCookie);

Vue.config.productionTip = false;

new Vue({
	el: '#approot',
	template: '<App/>',
	components: {App},
});


// WEBPACK FOOTER //
// ./src/index.js